import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCompanyVerificationCheck } from '../../hooks/useCompanyVerificationCheck';
import Routes from '../routes.enum';
import CompanyVerificationRequiredModal from '../../modules/common/modals/CompanyVerificationRequiredModal';

interface CompanyVerificationGuardProps {
  children: ReactNode;
}

const CompanyVerificationGuard = ({ children }: CompanyVerificationGuardProps) => {
  const navigate = useNavigate();
  const {
    isCompanyVerified,
    isCompanyVerificationRequired,
    isVerificationModalOpen,
    closeVerificationModal,
    checkVerificationAndProceed,
  } = useCompanyVerificationCheck();

  useEffect(() => {
    // If verification is required, trigger the check which will open the modal
    if (isCompanyVerificationRequired()) {
      checkVerificationAndProceed(() => {
        // This callback won't be called since verification is required
      });
    }
  }, [isCompanyVerificationRequired, checkVerificationAndProceed]);

  const handleModalClose = () => {
    closeVerificationModal();
    // Navigate back to dashboard when modal is closed
    navigate(Routes.Dashboard);
  };

  // If company is verified, render children
  if (isCompanyVerified()) {
    return children;
  }

  // If company is not verified, show verification modal and don't render children
  return (
    <CompanyVerificationRequiredModal
      open={isVerificationModalOpen}
      onClose={handleModalClose}
    />
  );
};

export default CompanyVerificationGuard;
